<template>
    <v-card>
        <v-card-text class="text-center pa-7" v-if="!loaded">
            <v-progress-circular
                indeterminate
                color="indigo"
                class="ma-5"
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
            <chart
                ref="chart"
                height="300"
                :options="options"
                :series="series"
            ></chart>
        </v-card-text>
    </v-card>
</template>

<script>
import ApexChartHelper from './ApexChartHelper'
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['resellerTypeRefer'],

    components: {
        chart: VueApexCharts,
    },

    data: () => {
        return {
            loaded: false,
            labels: [],
            series: [],
        }
    },

    watch: {
        resellerTypeRefer() {
            this.loaded = false
            this.fetchData().then(() => (this.loaded = true))
        },
    },

    computed: {
        helper() {
            return new ApexChartHelper()
        },

        options() {
            return {
                chart: {
                    type: 'area',
                },
                colors: ['#118eed', '#f3f32e', '#09ed8e', '#db1623'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'straight',
                },
                title: this.helper.title({ text: 'Faturado em Produtos' }),
                xaxis: {
                    type: 'datetime',
                },
                tooltip: {
                    x: {
                        format: 'MM/yyyy',
                    },
                    y: {
                        formatter: value => {
                            return this.$n(value ? value : 0, 'currency')
                        },
                    },
                },
            }
        },
    },

    methods: {
        async fetchData() {
            const which =
                'which[]=product-charges.total&which[]=product-charges.paid&which[]=product-charges.overdue&which[]=product-charges.upToDate'
            let endpoint = '/dashboard/kpis/monthly?' + which

            if (this.resellerTypeRefer) {
                endpoint +=
                    '&aggregators[reseller_type_refer]=' +
                    this.resellerTypeRefer
            }

            let res = await this.$http.get(endpoint)
            this.dataHandler(res.data)
        },

        dataHandler(data) {
            this.series = []
            let charges = []
            let payments = []
            let overdue = []
            let upToDate = []

            this.labels = Object.keys(data)

            this.labels.forEach(element => {
                const totalValue = data[element]['product-charges.total']
                    ? data[element]['product-charges.total']
                    : 0
                const upToDateValue = data[element]['product-charges.upToDate']
                    ? data[element]['product-charges.upToDate']
                    : 0
                const paidValue = data[element]['product-charges.paid']
                    ? data[element]['product-charges.paid']
                    : 0
                const overdueValue = data[element]['product-charges.overdue']
                    ? data[element]['product-charges.overdue']
                    : 0

                charges.push({ x: element, y: totalValue })
                upToDate.push({ x: element, y: upToDateValue })
                payments.push({ x: element, y: paidValue })
                overdue.push({ x: element, y: overdueValue })
            })

            this.series.push({ name: 'Total', data: charges })
            this.series.push({ name: 'Em dia', data: upToDate })
            this.series.push({ name: 'Recebido', data: payments })
            this.series.push({ name: 'Atrasado', data: overdue })
        },
    },

    created() {
        this.fetchData().then(() => (this.loaded = true))
    },
}
</script>

<style></style>
